import { DateFormatEnum as e } from "../types/date-time-format.js";
import { LanguageCodeEnum as t } from "@systemeio/types";
//#region src/date-picker/utils/date-utils.ts
var n = /^\d{4}-\d{2}-\d{2}$/, r = (e, n) => new Date(new Intl.DateTimeFormat(t.ENGLISH, {
	day: "2-digit",
	hour: "numeric",
	minute: "numeric",
	month: "2-digit",
	second: "numeric",
	timeZone: n,
	year: "numeric"
}).format(e)), i = (e, t) => e ? e instanceof Date ? r(e, t) : n.test(e) ? /* @__PURE__ */ new Date(`${e}T00:00:00`) : e.match(/([-+]\d+:?\d+)$/) ? r(new Date(e), t) : new Date(e) : r(/* @__PURE__ */ new Date(), t), a = (e, t) => i(e, t), o = (e) => {
	let t = (e) => `${e}`.padStart(2, "0");
	return `${e.getFullYear()}-${t(e.getMonth() + 1)}-${t(e.getDate())}T${t(e.getHours())}:${t(e.getMinutes())}:${t(e.getSeconds())}`;
}, s = (t) => {
	switch (t) {
		case e.dateFirst: return "en-GB";
		case e.monthFirst: return "en-US";
		default: return;
	}
}, c = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(s(t?.dateFormat), {
	day: "2-digit",
	month: "2-digit",
	timeZone: t?.timeZone,
	year: "numeric"
});
//#endregion
export { c as formatDate, a as getDate, i as setDateWithTimezone, o as toISOStringWithoutTimezone };
